import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_event/$eventSlug/jornadas/$journeyId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      href: `/jornadas/${params.journeyId}`,
      replace: true
    })
  }
})
